import { combineReducers } from 'redux';
import create from './create/reducer';
import preview from './preview/reducer';
import read from './read/reducer';

export default combineReducers({ create, preview, read });
